import React from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';
import { ActionsPropsInterface } from './ActionsTypes';
import * as Styled from './ActionsStyles';

function Actions({ isLoading, innerRef, onCancel }: ActionsPropsInterface) {
  const { amplitudeEvent } = useAmplitude();
  const nameEvent = 'journey_create_button_form_clicked';

  return (
    <Styled.Wrapper ref={innerRef}>
      <FuelFlex defaultProps={{ gap: 'km3', justifyContent: 'flex-end' }}>
        <FuelButton
          data-testid="button-cancel"
          variant="tertiary"
          size="large"
          type="button"
          onClick={() => {
            amplitudeEvent(nameEvent, {
              source: 'back',
            });
            onCancel();
          }}
        >
          Voltar
        </FuelButton>
        <FuelButton
          data-testid="button-done"
          size="large"
          type="submit"
          isLoading={isLoading}
          onClick={() => {
            amplitudeEvent(nameEvent, {
              source: 'create-journey',
            });
          }}
        >
          Monitorar
        </FuelButton>
      </FuelFlex>
    </Styled.Wrapper>
  );
}

export default Actions;
